import { TestRun, TestResult } from '../../types';
import testSubTypeRenderer from './testSubTypeRenderer';

const testTypeRenderer = (value: TestRun | TestResult) =>
  testSubTypeRenderer(value.metadata.test_sub_type);

export default testTypeRenderer;
